import * as types from './types'

export const setIsFetching = isFetching => ({
  type: types.SET_IS_FETCHING,
  payload: isFetching
})

export const setData = data => ({
  type: types.SET_DATA,
  payload: data
})
